import React from "react";

const EmptyDetail = () => (
  <div style={{ textAlign: "center", padding: "24px" }}>
    Aucune donnée disponible
  </div>
);
export default EmptyDetail;
